'use client';

import { GtwoOrange } from '@/components/_rebrand/logos';
import { FC } from 'react';
import IconTileBreakup from './IconTileBreakup';

export interface ProductAwardsProps {
  hideComponent?: boolean;
  title: React.ReactNode;
  description: string;
  image: React.ReactNode;

  reviewImage: React.ReactNode;
  reviewCta: {
    title: string;
    href: string;
  };

  awardBadges: React.ReactNode[];
}

const ProductAwards: FC<ProductAwardsProps> = ({ hideComponent, title, description, image, awardBadges = [] }) => {
  return (
    <>
      <div className={`${hideComponent ? "hidden" : "flex"} bg-white-100 px-3 py-6 md:px-container-desktop md:pt-12 pb-16 md:pb-20`}>
        <div className="max-w-grid mx-auto">

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-gutter-mobile md:gap-x-gutter-desktop gap-y-3">
            <div className="lg:col-span-5 flex flex-col gap-3 md:gap-6 relative">
              <div className='flex flex-col gap-3'>
                <p className='text-30/36 md:text-36/42 font-500 tracking-tight text-blue-900'>{title}</p>
                <p className='text-17/24 text-blue-1000 lg:pr-8'>{description}</p>
              </div>
              <div className="flex w-full md:w-[90%] border-[1px] border-solid border-gray-200"></div>

              <div className='flex flex-col gap-3 items-start'>
                <div className="flex relative items-center rounded-40">
                  <div className="flex bg-white p-[8px] rounded-[8px]">
                    <div className="text-12/16 p-1">{GtwoOrange()}</div>
                  </div>
                  <div className="flex flex-wrap ml-[16px]">
                    <div className="text-caption1 md:text-p2 pr-2 text-gray-500 font-500 w-full">2025</div>
                    <div className="text-caption1 md:text-p2 pr-0 md:pr-2 text-blue-900 font-500 w-full">Best Customer Service Software</div>
                  </div>
                </div>
                <div className="relative 2xl:absolute bottom-0">
                  <div className="hidden md:flex items-center justify-between gap-2 xl:pr-8 border-2 border-gray-700 relative bottom-0 w-full">
                    {awardBadges.map((awardImage, index) => (
                      <div key={index} className="flex flex-col justify-center items-center last:hidden last:md:block">
                        {awardImage}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className='overflow-hidden rounded-10'>
                {image}
              </div>
              <div className="flex md:hidden mt-[50px] items-center justify-between gap-2 xl:pr-8 border-2 border-gray-700 relative bottom-0 w-full">
                {awardBadges.map((awardImage, index) => (
                  <div key={index} className="flex flex-col justify-center items-center last:hidden last:md:block">
                    {awardImage}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:block h-30 md:h-[10vw] relative w-full overflow-hidden mt-[-120px]">
        <IconTileBreakup data-fill-color="#FFF" className="absolute left-[-100vw] right-[-100vw] bottom-[-1px] w-[300vw] md:left-0 md:right-0 md:w-full h-auto text-gray-100" />
      </div>
      <div className="flex md:hidden relative w-full mt-[-80px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="360" height="35" viewBox="0 0 360 35" fill="none" className="w-full">
          <path fillRule="evenodd" clipRule="evenodd" d="M-222 0.302527H-87.8333L-87.8337 11.605H46.333V0.302444L-87.8333 0.302527V-11H-222V0.302527ZM582 0.302527H447.833V-11H582V0.302527ZM447.833 0.302527L447.833 11.605H313.667V0.302444L447.833 0.302527ZM180.5 22.9079H313.667V11.6054H180.5H179.5H46.3331V22.9079H179.5H180.5ZM582 40.921H447.833V35.0002H314V23.0002H447.833V14.4307H582V40.921ZM-87.8333 40.921H-222V14.4307H-87.8333V23.0002H45.9999V35.0002H-87.8333V40.921Z" fill="white" />
        </svg>
      </div>
    </>
  )
};

export default ProductAwards;
